import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Schedule } from "@mui/icons-material";
import { ClickAwayListener, TextField, Box, useTheme, Typography, Grid, useMediaQuery, } from "@mui/material";
import { LocalizationProvider, StaticDateRangePicker, } from "@mui/x-date-pickers-pro";
import { DateTime } from "luxon";
import { createRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import { NerdPickerWrapper } from "../nerdPickersWrapper";
import { CustomLuxonAdapter } from "../nerdDatePicker/customLuxonAdapter";
const defaultlocaleStringFormat = {
    weekday: "long",
    month: "long",
    day: "2-digit",
};
/**
 *
 * @param {NerdDateRangePickerProps} props Props
 * @returns {ReactElement} NerdDateTimePicker
 */
export default function NerdDateRangePicker(props) {
    const { startTextFieldProps, endTextFieldProps, dateRangePickerProps, onChange, value, hideIcon, localeStringFormat = defaultlocaleStringFormat, } = props;
    const [startTextFieldValue, setStartTextFieldValue] = useState(value !== null && value[0] !== null
        ? value[0].toLocaleString(localeStringFormat)
        : "");
    const [endTextFieldValue, setEndTextFieldValue] = useState(value !== null && value[1] !== null
        ? value[1].toLocaleString(localeStringFormat)
        : "");
    const [tmpValue, setTmpValue] = useState(value);
    const [anchorEl, setAnchorEl] = useState(null);
    const [startError, setStartError] = useState(false);
    const [endError, setEndError] = useState(false);
    const adapter = new CustomLuxonAdapter({ locale: i18n.language });
    const theme = useTheme();
    const isDownMd = useMediaQuery(theme.breakpoints.down("md"));
    const { t } = useTranslation("components", { i18n: i18n });
    const inputRef = createRef();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const setTextFieldsValue = (value) => {
        let startDate = "";
        let endDate = "";
        if (value[0] !== null)
            startDate = value[0].toLocaleString(localeStringFormat);
        if (value[1] !== null)
            endDate = value[1].toLocaleString(localeStringFormat);
        setStartTextFieldValue(startDate);
        setEndTextFieldValue(endDate);
    };
    useEffect(() => {
        setTmpValue(value);
        setTextFieldsValue(value);
    }, [value]);
    useEffect(() => {
        setTextFieldsValue(tmpValue);
    }, [tmpValue]);
    const onStartTextFieldValueChange = (newValue) => {
        setStartTextFieldValue(newValue);
    };
    const onEndTextFieldValueChange = (newValue) => {
        setEndTextFieldValue(newValue);
    };
    const onStartTextFieldBlur = (e) => {
        const date = adapter.date(e.target.value);
        if (date.isValid) {
            const newDate = value[0]?.set({
                day: date.day,
                month: date.month,
                ...(e.target.value.includes(date.year.toString()) && {
                    year: date.year,
                }),
            });
            if (value[0] &&
                value[1] &&
                newDate &&
                newDate.toMillis() != value[0].toMillis()) {
                setStartTextFieldValue(date.toLocaleString(localeStringFormat));
                onChange([newDate, newDate.plus(value[1].diff(value[0]))]);
            }
        }
    };
    const onEndTextFieldBlur = (e) => {
        const date = adapter.date(e.target.value);
        if (date.isValid) {
            const newDate = value[1]?.set({
                day: date.day,
                month: date.month,
                ...(e.target.value.includes(date.year.toString()) && {
                    year: date.year,
                }),
            });
            if (value[1] && newDate && newDate.toMillis() != value[1].toMillis()) {
                setStartTextFieldValue(date.toLocaleString(localeStringFormat));
                onChange([value[0], newDate]);
            }
        }
    };
    const onDateChange = (newValue) => {
        setTmpValue(newValue);
        if (!isDownMd)
            onChange(newValue);
    };
    useEffect(() => {
        let startError = false;
        let endError = false;
        if ((startTextFieldProps && !adapter.date(startTextFieldValue).isValid) ||
            startTextFieldProps?.error)
            startError = true;
        if ((endTextFieldValue && !adapter.date(endTextFieldValue).isValid) ||
            endTextFieldProps?.error)
            endError = true;
        setEndError(endError);
        setStartError(startError);
    }, [startTextFieldValue, endTextFieldValue]);
    return (_jsx(ClickAwayListener, { onClickAway: handleClose, children: _jsx("div", { children: _jsxs(LocalizationProvider, { dateAdapter: CustomLuxonAdapter, adapterLocale: i18n.language, children: [_jsxs(Box, { sx: { display: "flex", alignItems: "center" }, children: [!hideIcon && (_jsx(Schedule, { sx: { color: "action.active", mr: 1, my: 0.5 } })), _jsxs(Grid, { container: true, spacing: 1, children: [_jsx(Grid, { item: true, children: _jsx(TextField, { inputRef: inputRef, focused: anchorEl === null ? false : true, fullWidth: true, label: t("nerdDatePicker.date"), size: "small", variant: "standard", ...startTextFieldProps, error: startError, helperText: !anchorEl
                                                ? startError
                                                    ? t("nerdDatePicker.invalid_date")
                                                    : startTextFieldProps?.helperText
                                                        ? startTextFieldProps?.helperText
                                                        : ""
                                                : "", value: startTextFieldValue, onClick: (e) => {
                                                handleClick(e);
                                                startTextFieldProps?.onClick?.(e);
                                            }, onChange: (e) => {
                                                onStartTextFieldValueChange(e.target.value);
                                                startTextFieldProps?.onChange?.(e);
                                            }, onBlur: (e) => {
                                                onStartTextFieldBlur(e);
                                                startTextFieldProps?.onBlur?.(e);
                                            } }) }), _jsx(Grid, { item: true, mt: 1, children: _jsx(Typography, { fontSize: 24, children: "-" }) }), _jsx(Grid, { item: true, children: _jsx(TextField, { inputRef: inputRef, focused: anchorEl === null ? false : true, fullWidth: true, label: t("nerdDatePicker.date"), size: "small", variant: "standard", ...endTextFieldProps, error: endError, helperText: !anchorEl
                                                ? endError
                                                    ? t("nerdDatePicker.invalid_date")
                                                    : endTextFieldProps?.helperText
                                                        ? endTextFieldProps?.helperText
                                                        : ""
                                                : "", value: endTextFieldValue, onClick: (e) => {
                                                handleClick(e);
                                                endTextFieldProps?.onClick?.(e);
                                            }, onChange: (e) => {
                                                onEndTextFieldValueChange(e.target.value);
                                                endTextFieldProps?.onChange?.(e);
                                            }, onBlur: (e) => {
                                                onEndTextFieldBlur(e);
                                                endTextFieldProps?.onBlur?.(e);
                                            } }) })] })] }), _jsx(NerdPickerWrapper, { popperProps: {
                            open: anchorEl === null ? false : true,
                            anchorEl: anchorEl,
                            sx: {
                                zIndex: theme.zIndex.modal,
                                boxShadow: theme.shadows[5],
                                borderRadius: "4px",
                                backgroundColor: "inherit",
                            },
                        }, dialogProps: {
                            open: anchorEl === null ? false : true,
                            onClose: handleClose,
                        }, dialogActionBarProps: {
                            onAccept() {
                                onChange(tmpValue);
                                handleClose();
                            },
                            onCancel() {
                                setTmpValue(value);
                                handleClose();
                            },
                            onClear() {
                                onChange([null, null]);
                                handleClose();
                            },
                            onSetToday() {
                                onChange([DateTime.now(), DateTime.now()]);
                                handleClose();
                            },
                            actions: dateRangePickerProps?.componentsProps?.actionBar
                                ?.actions || ["today", "cancel", "accept"],
                        }, popperActionBarProps: {
                            onAccept() {
                                onChange(tmpValue);
                                handleClose();
                            },
                            onCancel() {
                                setTmpValue(value);
                                handleClose();
                            },
                            onClear() {
                                onChange([null, null]);
                                handleClose();
                            },
                            onSetToday() {
                                onChange([DateTime.now(), DateTime.now()]);
                                handleClose();
                            },
                            actions: dateRangePickerProps?.componentsProps?.actionBar
                                ?.actions || ["today"],
                        }, children: _jsx(Box, { sx: {
                                "& .MuiPickerStaticWrapper-content": {
                                    borderRadius: "4px",
                                },
                            }, children: _jsx(StaticDateRangePicker, { displayStaticWrapperAs: isDownMd ? "mobile" : "desktop", showToolbar: false, componentsProps: {
                                    actionBar: {
                                        actions: [],
                                    },
                                }, disableMaskedInput: true, ...dateRangePickerProps, value: tmpValue, onAccept: handleClose, onChange: (value, keyboardInputValue) => {
                                    onDateChange(value);
                                    dateRangePickerProps?.onChange?.(value, keyboardInputValue);
                                }, renderInput: (params) => _jsx(TextField, { ...params }) }) }) })] }) }) }));
}
